import {ref} from 'vue';
import {useMutation, useQuery} from '@tanstack/vue-query';
import axios from 'axios';
import WebsiteUrlStep from '@/components/website/v2/steps/WebsiteUrlStep.vue';
import LocationStep from '@/components/website/v2/steps/LocationStep.vue';
import {errorToast} from '@/composables/useToasts';

const websiteUrl = ref('');
const industry = ref('');
const country = ref('');
const region = ref('');
const location = ref('');

const currentStep = ref(1);

const steps = {
  1: WebsiteUrlStep,
  2: LocationStep,
};

export const nextStep = () => {
  if (currentStep.value < Object.keys(steps).length) {
    currentStep.value++;
  }
};

export const previousStep = () => {
  currentStep.value--;
};

export const useCreateWebsite = () => {
  const createWebsiteMutation = useMutation({
    mutationFn: async () => await axios.post('/ajax/website/store', {
      website: websiteUrl.value,
      industry_gcid: industry.value,
      country_id: country.value,
      specific_location_id: location.value,
    }),
    onSuccess: (response) => {
      const {data} = response;
      window.location.href = data.redirectUrl;
    },
    onError: (error) => {
      errorToast(
        error.response?.data?.message ??
        'Something went wrong, please try again later.',
        'Add website failed'
      );
    },
  });

  const industriesQuery = useQuery({
    queryKey: ['industries'],
    queryFn: async () => {
      const {data} = await axios.get('/ajax/v2/website/industries');

      return data.data.reduce((acc, item) => {
        acc[item.gcid] = item.name;
        return acc;
      }, {});
    }
  });

  const countriesQuery = useQuery({
    queryKey: ['countries'],
    queryFn: async () => {
      const {data} = await axios.get('/ajax/v2/website/countries');

      return data;
    }
  });

  return {
    websiteUrl,
    industry,
    country,
    region,
    location,
    currentStep,
    steps,
    createWebsiteMutation,
    industriesQuery,
    countriesQuery
  };
};
